import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { platformGuard } from './shared/guards/platform.guard';
import { routes as publicRoutes } from './app/public/mobile-public.routes';
import { routes as privateRoutes } from './app/private/mobile-private.routes';
import { routes as webPrivateRoutes } from './web/private/web-private.routes';
import { LoginWebComponent } from './web/public/login/login.component';
import { RecuperaPasswordWebComponent } from './web/public/recupera-password/recupera-password.component';
import { PrivateWebComponent } from './web/private/private-web.component';
import { ResetPasswordComponent as SharedResetPasswordComponent } from './shared/components/public/reset-password/reset-password.component';
import { FirmaOtpGateComponent } from './web/private/firma/firma-otp-gate/firma-otp-gate.component';
import { FirmaDettaglioComponent } from './web/private/firma/firma-dettaglio/firma-dettaglio.component';
import { FirmaDettaglioSwitcherComponent } from './web/public/firma-otp/firma-dettaglio-switcher.component';
import { MicrosoftCallbackComponent } from './shared/components/public/microsoft-callback/microsoft-callback.component';

export const routes: Routes = [
	{
		path: 'auth/microsoft/callback',
		component: MicrosoftCallbackComponent,
	},
	{
		path: 'app',
		data: { platform: 'app' },
		canActivate: [platformGuard],
		children: [
			{ path: '', redirectTo: 'public/login', pathMatch: 'full' },
			{ path: 'public', children: publicRoutes },
			{ path: 'dashboard', canActivate: [AuthGuard], children: privateRoutes },
		],
	},
	{
		path: 'web',
		data: { platform: 'web' },
		canActivate: [platformGuard],
		children: [
			{ path: '', redirectTo: 'public/login', pathMatch: 'full' },
			{
				path: 'public',
				children: [
					{ path: 'login', component: LoginWebComponent },
					{ path: 'recupera-password', component: RecuperaPasswordWebComponent },
					{ path: 'firma-otp/:idTransaction', component: FirmaOtpGateComponent },
					{ path: 'firma-otp/dettaglio/:idTransaction', component: FirmaDettaglioSwitcherComponent, data: { isPublic: true } },
				],
			},
			{ path: 'private', component: PrivateWebComponent, canActivate: [AuthGuard], children: webPrivateRoutes },
		],
	},
	{
		path: 'public',
		children: [{ path: 'reset-password', component: SharedResetPasswordComponent }],
	},
	{ path: '', redirectTo: '/web/public/login', pathMatch: 'full' },
	{ path: '**', redirectTo: '/web/public/login' },
];
